// 작성중 / 심사확인 페이지로 이동할 수 있도록 해주는 네비게이션바
import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Menu, Layout, Icon } from 'antd';

import '../../styles/UploadStickerNav.css';

const NavUI = props => {
  return (
    <Layout.Sider theme="light" width="215" className="upload-nav-sider">
      <Menu
        mode="inline"
        selectedKeys={[props.selectedKey]}
        style={{height:'100%', paddingTop: 44}}
      >
        {
            props.pages.map( pageData  =>
            <Menu.Item key={pageData.key}>
                <Link to={pageData.pathname}className="upload-nav" activeClassName="upload-nav-active">
                  <div className="upload-nav-box">
                    { React.isValidElement(pageData.icon) ? pageData.icon : <Icon type={pageData.icon} style={{fontSize: 18}}/>}
                    <FormattedMessage
                        id={pageData.title.id}
                        defaultMessage={pageData.title.text}
                        />
                  </div>
                </Link>
            </Menu.Item>
            )
        }
      </Menu>
    </Layout.Sider>
  );

};



export default withRouter(NavUI);
